export default __webpack_public_path__ + "static/media/login-background.a51966c4.svg";